import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// 扩展 tailwind-merge，让它正确识别自定义的 iOS text styles
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // iOS text styles 属于 fontSize 组
      'font-size': [
        'text-large-title',
        'text-title-1',
        'text-title-2',
        'text-title-3',
        'text-headline',
        'text-body',
        'text-callout',
        'text-subhead',
        'text-footnote',
        'text-caption-1',
        'text-caption-2',
        'text-2xs',
      ],
      // iOS semantic colors 属于 textColor 组（不与 fontSize 冲突）
      'text-color': [
        'text-label',
        'text-secondary-label',
        'text-tertiary-label',
        'text-quaternary-label',
      ],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => customTwMerge(clsx(inputs))
